export default __webpack_public_path__ + "static/media/warning--single-reverse-curve--g1.8219bd1a.png";